import React from 'react';
import Typography from '@lib/components/Typography/Typography';

interface Props {
  title: string;
}

export default function FormSectionHeader({ title }: Props) {
  return <Typography variant="h3">{title}</Typography>;
}
